import { EditableProcessedText } from "./EditableProcessedText";

interface ProcessedTabProps {
  processedText: string | null;
  fileName: string;
  hideActions?: boolean;
  recordId: string;
  onUpdate?: (newText: string) => void;
  readOnly?: boolean;
  onEditingStateChange?: (isEditing: boolean, hasChanges: boolean) => void;
}

export const ProcessedTab = ({
  processedText,
  fileName,
  hideActions = false,
  recordId,
  onUpdate,
  readOnly = false,
  onEditingStateChange,
}: ProcessedTabProps) => {
  return (
    <EditableProcessedText
      processedText={processedText}
      recordId={recordId}
      onUpdate={onUpdate}
      readOnly={readOnly || hideActions}
      onEditingStateChange={onEditingStateChange}
    />
  );
};
